export const normalize = (value: string) => {
  if (value) {
    return value
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[-[\]\s{}()*+?.,\\^$|#]/g, '')
      .toLowerCase()
  }

  return ''
}

export const escapeRegExp = (text: string) => {
  if (!text) {
    return ''
  }
  return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}
